import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

const fmt = (d) => d ? new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

export default function Anotacoes() {
  const [aba, setAba] = useState('pendente');
  const [itens, setItens] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const carregar = useCallback(async () => {
    try {
      const { data } = await api.get(`/anotacoes?status=${aba}`);
      setItens(data);
    } catch { toast.error('Erro ao carregar anotações'); }
    finally { setCarregando(false); }
  }, [aba]);

  useEffect(() => { setCarregando(true); carregar(); }, [carregar]);

  const resolver = async (id, status) => {
    try {
      await api.put(`/anotacoes/${id}/status`, { status });
      setItens(l => l.filter(i => i.id !== id));
      toast.success(status === 'concluido' ? 'Anotação concluída' : 'Anotação cancelada'); window.dispatchEvent(new Event('anotacoes:atualizadas'));
    } catch (e) { toast.error(e.response?.data?.erro || 'Erro ao atualizar'); }
  };

  const tab = (id, label) => (
    <button onClick={() => setAba(id)} style={{
      padding: '6px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600,
      border: '1px solid var(--border)', color: aba === id ? '#fff' : 'var(--text-muted)',
      background: aba === id ? 'var(--tema-cor, #137aba)' : 'transparent',
    }}>{label}</button>
  );

  const btn = (cor) => ({
    padding: '6px 16px', borderRadius: 8, border: 'none', cursor: 'pointer',
    fontSize: 13, fontWeight: 600, color: '#fff', background: cor,
  });

  return (
    <div style={{ padding: 24, height: '100vh', overflowY: 'auto', boxSizing: 'border-box', flex: 1 }}>
      <h2 style={{ color: '#fff', marginBottom: 14 }}>📝 Anotações</h2>
      <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
        {tab('pendente', 'Pendentes')}
        {tab('historico', 'Histórico')}
      </div>
      {carregando ? (
        <p style={{ color: 'var(--text-muted)' }}>Carregando...</p>
      ) : itens.length === 0 ? (
        <p style={{ color: 'var(--text-muted)' }}>{aba === 'pendente' ? 'Nenhuma anotação pendente.' : 'Nada no histórico ainda.'}</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720 }}>
          {itens.map(n => (
            <div key={n.id} style={{ border: '1px solid var(--border)', borderRadius: 10, padding: 14, background: 'rgba(255,255,255,0.03)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                <strong style={{ color: '#fff' }}>{n.contato_nome}</strong>
                <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>Mensagem de {fmt(n.mensagem_em)}</span>
              </div>
              <p style={{ color: '#e5e7eb', margin: '10px 0', whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{n.conteudo}</p>
              {aba === 'pendente' ? (
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button style={btn('#6b7280')} onClick={() => resolver(n.id, 'cancelado')}>Cancelar</button>
                  <button style={btn('#16a34a')} onClick={() => resolver(n.id, 'concluido')}>Concluído</button>
                </div>
              ) : (
                <div style={{ fontSize: 12, color: n.status === 'concluido' ? '#4ade80' : '#9ca3af' }}>
                  {n.status === 'concluido' ? '✓ Concluído' : '✕ Cancelado'} em {fmt(n.resolvido_em)}
                  {n.criado_por ? ` · por ${n.criado_por}` : ''}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
